module.exports = __webpack_public_path__ + "static/img/atm-step-2.d97d9649.png";